<template>
  <Dialog :common-dialog="productDialog" :dialog-width="dialog_width">
    <template v-slot:title>
      <v-layout class="line-item-title">
        <v-flex class="line-item-title-text">
          <span class="text-capitalize line-item-title-label"
            >Selected Customer Asset</span
          >
          <span class="line-item-title-count">({{ getSelectedItem }})</span>
          <!--  <v-icon class="mx-2 color-custom-blue" small>mdi-record</v-icon>
          Line Item -->
        </v-flex>
        <v-flex
          v-if="!isMobile"
          class="line-item-title-actions text-right desktop-line-item-actions"
        >
          <v-btn
            style="height: 32px !important"
            class="custom-bold-button mr-2 dialog-action-btn"
            depressed
            :disabled="vStateLoading"
            color="cyan white--text"
            v-on:click="save_line_item()"
            >Save</v-btn
          >
          <v-btn
            style="height: 32px !important"
            class="custom-bold-button"
            depressed
            :disabled="vStateLoading"
            v-on:click="$emit('close', true)"
            >Close</v-btn
          >
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <div class="line-item-dialog">
        <div
          v-if="vLineItemAlpha && vLineItemAlpha.length"
          class="d-flex mb-2"
          style="overflow-x: scroll"
        >
          <!--  <div
            style="position: relative"
            v-for="(alpha, index) in vLineItemAlpha"
            :key="`alphabet-${index}`"
            :class="{ 'alpha-exist': alpha.exist }"
            class="alph-listing custom-border-right"
          >
            <v-btn
              color="cyan white--text custom-bold-button"
              depressed
              tile
              :disabled="vStateLoading"
              :text="alphabet == alpha.value"
              v-on:click="filter_alpha(alpha.value)"
            >
              {{ alpha.label }}
            </v-btn>
            <v-icon v-if="alpha.exist" color="red">mdi-record</v-icon>
          </div> -->
        </div>
        <div
          v-if="lineItemCategories && lineItemCategories.length && false"
          class="d-flex mb-2 line-item-filters"
          style="overflow-x: scroll"
        >
          <div
            style="position: relative"
            v-for="(cat, index) in lineItemCategories"
            :key="`category-${index}`"
            class="custom-border-right"
          >
            <v-btn
              color="cyan white--text custom-bold-button"
              depressed
              tile
              :disabled="vStateLoading"
              :text="category == cat.value"
              v-on:change="filter_cat(cat.value)"
            >
              {{ cat.label }}
            </v-btn>
          </div>
        </div>
        <div class="d-flex mb-2 line-item-filters">
          <v-text-field
            v-model="search"
            class="line-item-header-text px-0 v-slot-m-none filter-item"
            placeholder="Search..."
            dense
            filled
            solo
            :disabled="vStateLoading"
            clearable
            flat
            color="cyan"
            style="max-width: 400px"
            v-on:click:clear="clearSearch"
            :append-outer-icon="isMobile ? 'mdi-magnify' : ''"
            @click:append-outer="handleSearch"
          />
          <v-btn
            v-if="!isMobile"
            style="height: 32px !important"
            class="custom-bold-button ml-2 filter-button"
            depressed
            :disabled="vStateLoading"
            v-on:click="handleSearch()"
            color="cyan white--text"
            >Search</v-btn
          >
          <v-autocomplete
            hide-details
            v-model.trim="filter_categoty"
            :items="lineItemCategories"
            clearable
            v-on:click:clear="filter_categoty = null"
            :style="categoryStyle"
            dense
            flat
            filled
            placeholder="Category"
            item-color="cyan"
            class="ml-2 custom-boder-color"
            color="cyan"
            solo
            v-on:change="filter_cat($event)"
            item-value="value"
            item-text="label"
          >
          </v-autocomplete>
        </div>
        <div>
          <div class="d-flex grey lighten-4 line-item-table-header">
            <div
              class="font-weight-600 py-2 text-center d-flex justify-center"
              style="width: 5%"
            >
              <v-checkbox
                v-on:change="update_all_line_item($event)"
                hide-details
                :disabled="vStateLoading"
                class="my-0 py-0 px-0 mx-0 dense-checkbox"
                color="cyan"
              />
            </div>
            <div
              class="color-custom-blue py-2 font-weight-700 text-left text-capitalize product-header"
              :style="getStyle(productType)"
            >
              <template v-if="productType == 'tools'"> Tools</template>
              <template v-else-if="productType == 'equipment'">
                Customer Asset</template
              >
              <template v-else-if="productType == 'goods'"> Products</template>
              <template v-else>{{ productType }}</template>
            </div>
            <div
              v-if="productType == 'goods' || productType == 'parts'"
              class="color-custom-blue py-2 font-weight-700 text-left"
              style="width: 20%"
            >
              Available Quantity
            </div>
            <!-- <div
              v-if="productType == 'equipment'"
              class="color-custom-blue py-2 font-weight-700 text-left"
              style="width: 20%"
            >
              Sub-Location
            </div> -->
            <div
              v-if="moduleType != 8 && !hideUnitAndCost"
              class="color-custom-blue py-2 font-weight-700 text-left"
              :style="
                productType == 'goods' || productType == 'parts'
                  ? 'width: 20%'
                  : ' width: 25%'
              "
            >
              Selling/Unit Cost
            </div>
            <div
              v-if="!hideUnitAndCost"
              class="color-custom-blue py-2 font-weight-700 text-left"
              style="width: 10%"
            >
              UOM
            </div>
            <div
              v-if="moduleType != 8"
              class="color-custom-blue py-2 font-weight-700 text-left quantity-header"
              :style="
                productType == 'goods' || productType == 'parts'
                  ? 'width: 20%'
                  : ' width: 25%'
              "
            >
              Quantity
            </div>
          </div>
          <div style="overflow-y: scroll; max-height: calc(100vh - 360px)">
            <div v-if="vStateLoading" class="my-4 py-4">
              <v-progress-linear
                color="cyan"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
            <div v-else-if="lineItemList && lineItemList.length">
              <div
                v-for="(row, index) in lineItemList"
                :key="index"
                class="d-flex pt-1 custom_row"
                :class="getDisabled(row) ? 'eqp-opacity' : ''"
              >
                <div
                  class="font-weight-600 text-center d-flex justify-center mt-2"
                  style="width: 5%;"
                >
                  <v-checkbox
                    v-model="row.status"
                    :disabled="getDisabled(row)"
                    hide-details
                    class="my-0 py-0 px-0 mx-0 dense-checkbox"
                    color="cyan"
                  />
                </div>
                <div class="text-left" :style="getStyle(productType)">
                  <div class="d-flex">
                    <div>
                      <v-avatar size="32">
                        <img
                          v-if="row?.image?.url"
                          :src="row?.image?.url"
                          :alt="row?.image?.name"
                        />
                        <img v-else :src="$defaultImage" />
                      </v-avatar>
                    </div>
                    <div style="width: 100%" class="ml-0">
                      <div class="line-item-product-header">
                        <div class="line-item-product-label text-truncate">
                          {{ row.product || row.name || row.title || '-' }}
                        </div>
                        <div
                          v-if="(row && row.barcode) || (row && row.serial_no)"
                          class="line-item-product-codes"
                        >
                          <v-chip
                            v-if="row && row.barcode"
                            label
                            color="chip-custom-blue"
                            outlined
                            x-small
                            class="text-white px-1"
                            style="font-weight: 700"
                          >
                            {{ row.barcode }}
                          </v-chip>
                          <v-chip
                            v-if="row && row.serial_no"
                            label
                            color="#f4c542"
                            text-color="#3b2f00"
                            outlined
                            x-small
                            class="px-1 mr-4"
                            style="font-weight: 700"
                          >
                            {{ row.serial_no }}
                          </v-chip>
                        </div>
                      </div>
                      <!-- <div
                        v-if="row && row.description"
                        class="line-item-description text-truncate"
                        :title="row.description"
                      >
                        {{ row.description }}
                      </div> -->

                      <!--   <v-checkbox
                           v-if="row.type == 'product'"
                          inset
                          color="cyan"
                          label="As Equipment"
                          dense
                          class="pt-0 mt-2"
                          v-model="row.is_equipment" 
                          hide-details
                          :false-value="0"
                          :true-value="1"
                        > 
                      </v-checkbox>  -->
                      <div
                        v-if="row.has_property"
                        class="font-weight-600 d-flex align-center"
                      >
                        <!-- <template
                          v-if="
                            productType == 'equipment' && row && row.serial_no
                          "
                        >
                          <v-chip
                            label
                            color="chip-custom-blue"
                            outlined
                            class="text-white p-3 mr-2"
                            style="font-weight: 700; margin-top: -6px"
                            >{{ row.serial_no }}</v-chip
                          >
                        </template> -->
                        <!--  <template v-if="row?.property?.parent?.name">
                          <v-chip small>{{ row.property.parent.name }}</v-chip>
                          <v-icon class="px-1">mdi-chevron-right</v-icon>
                        </template>
                        <template v-if="row?.property?.child?.name">
                          <v-chip small style="padding: 12px !important">{{
                            row.property.child.name
                          }}</v-chip>
                          <v-icon class="px-1">mdi-chevron-right</v-icon>
                        </template>
                        <template v-if="row?.property?.type == 'child-child-'">
                          <v-chip small style="padding: 12px !important">
                            <div>
                              <div>
                                {{ row?.property?.property_name }}
                              </div>

                              <div>{{ row.property.name }}</div>
                            </div>
                          </v-chip>
                        </template>
                        <template v-if="row?.property?.type == 'child-'">
                          <v-chip small style="padding: 12px !important">
                            <div>
                              <div>
                                {{ row?.property?.property_name }}
                              </div>

                              <div>{{ row.property.name }}</div>
                            </div>
                          </v-chip>
                        </template>
                        <template v-if="row?.property?.type == 'parent-'">
                          <v-chip
                            small
                            style="padding: 12px !important"
                            v-if="row?.property?.property_name"
                          >
                            <div>
                              <div>
                                {{ row?.property?.property_name }}
                              </div>

                              <div>{{ row.property.name }}</div>
                            </div>
                          </v-chip>
                        </template> -->
                        <template v-if="isWarranty(row)">
                          <v-chip
                            :color="getWarrantyStatusColor(row.warranty_status)"
                            small
                            text-color="white"
                            class="ml-2"
                          >
                            Warranty
                          </v-chip>
                        </template>
                        <template
                          v-if="
                            (productType == 'equipment' ||
                              productType == 'tools') &&
                            row &&
                            row.preventive_id &&
                            row.preventive_id > 0 &&
                            showModules.preventive_maintanance
                          "
                        >
                          <v-chip
                            :color="row?.is_consumed ? 'red' : 'lightgray'"
                            class="ml-2"
                            small
                            text-color=""
                            outlined
                            v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.preventive_id,
                                'admin.preventive-maintanance.detail'
                              )
                            "
                          >
                            {{ row.preventive_barcode }}
                          </v-chip>
                        </template>
                        <template
                          v-if="
                            productType == 'equipment' &&
                            row &&
                            row.preventive_id &&
                            row.preventive_id > 0 &&
                            showModules.location
                          "
                        >
                          <v-chip
                            :color="row?.is_consumed ? 'red' : 'lightgray'"
                            class="ml-2"
                            small
                            text-color=""
                            outlined
                            v-on:click.prevent.stop="
                              routeToDetailLink(
                                row.preventive_id,
                                'admin.preventive-maintanance.detail'
                              )
                            "
                          >
                            {{ row.location }}
                          </v-chip>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="productType == 'goods' || productType == 'parts'"
                  class="text-center"
                  style="width: 20%"
                >
                  <v-text-field
                    class="line-item-header-text px-0"
                    placeholder="Available Quantity"
                    dense
                    filled
                    solo
                    type="number"
                    v-model="row.initial_stock"
                    flat
                    :disabled="getDisabled(row)"
                    v-on:keypress="limitDecimal($event, row.initial_stock)"
                    color="cyan"
                    :readonly="
                      productType == 'parts' ||
                      productType == 'tools' ||
                      productType == 'goods'
                    "
                    v-on:keydown="blockKeys($event, row.initial_stock)"
                    @paste="blockNegativePaste($event)"
                  />
                </div>
                <!-- <div
                  class="text-center"
                  style="width: 20%"
                  v-if="productType == 'equipment'"
                >
                  <v-autocomplete
                    class="line-item-header-text px-0"
                    placeholder="Sub-Location"
                    :items="subLocationList"
                    dense
                    filled
                    solo
                    type="text"
                    v-model="row.location"
                    flat
                    :disabled="getDisabled(row)"
                    v-on:keypress="limitDecimal($event, row.location)"
                    color="cyan"
                  />
                </div> -->
                <div
                  v-if="moduleType != 8 && !hideUnitAndCost"
                  class="text-center"
                  :style="
                    productType == 'goods' || productType == 'parts'
                      ? 'width: 20%'
                      : ' width: 25%'
                  "
                >
                  <v-text-field
                    class="d-flex line-item-header-text px-0"
                    placeholder="Selling/Unit Cost"
                    dense
                    filled
                    solo
                    type="number"
                    v-model="row.rate"
                    v-on:keydown="blockKeys($event, row.rate)"
                    @paste="blockNegativePaste($event)"
                    flat
                    :disabled="getDisabled(row)"
                    v-on:keypress="limitDecimal($event, row.rate)"
                    color="cyan"
                  />
                  <!-- Float chip to the start (left) under the input -->
                  <div style="display: flex; justify-content: flex-start">
                    <v-tooltip
                      top
                      content-class="custom-top-tooltip"
                      v-if="
                        moduleType === 3 &&
                        row.type == 'parts' &&
                        lodash.isEmpty(row?.get_default_suppliers) === false
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-bind="attrs"
                          v-on="on"
                          color="#e0e0e0 white--text"
                          style="max-width: fit-content"
                          label
                          class="p-2 mb-1 mt-1 text-uppercase font-weight-800"
                        >
                          <template
                            v-if="
                              row.type == 'parts' &&
                              lodash.isEmpty(row?.get_default_suppliers) ===
                                false
                            "
                          >
                            {{ row?.get_default_suppliers }}
                          </template>
                        </v-chip>
                      </template>
                      <span class="text-uppercase">
                        <template>Supplier Purchasing Price</template>
                      </span>
                    </v-tooltip>
                  </div>
                </div>
                <div v-if="!hideUnitAndCost" style="width: 10%">
                  <v-autocomplete
                    dense
                    filled
                    color="cyan"
                    item-color="cyan"
                    :items="vLineItemUnit"
                    placeholder="UOM"
                    solo
                    flat
                    item-text="text"
                    item-value="text"
                    class="pr-0 width-33"
                    v-model.trim="row.uom"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No UOM Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div
                  v-if="moduleType != 8"
                  class="text-center line-item-qty-cell"
                  :style="
                    productType == 'goods' || productType == 'parts'
                      ? 'width: 20%'
                      : ' width: 25%'
                  "
                >
                  <v-text-field
                    class="line-item-header-text px-0"
                    placeholder="Quantity"
                    dense
                    filled
                    type="number"
                    v-model="row.quantity"
                    solo
                    flat
                    v-on:keyup="checkAvailableQuantity(row)"
                    v-on:keypress="isNumber($event)"
                    v-on:keydown="blockKeys($event, row.quantity)"
                    @paste="blockNegativePaste($event)"
                    color="cyan"
                  />
                </div>
              </div>
            </div>
            <div v-else>
              <p
                class="m-0 row-not-found text-center font-weight-500 font-size-16"
              >
                <img
                  :src="$assetURL('media/error/empty.png')"
                  class="row-not-found-image"
                />
                Uhh... There are no item at the moment.
              </p>
            </div>
            <div v-if="isMobile" class="line-item-mobile-actions mt-4">
              <v-btn
                style="height: 32px !important"
                class="custom-bold-button dialog-action-btn"
                depressed
                :disabled="vStateLoading"
                color="cyan white--text"
                v-on:click="save_line_item()"
              >
                Save
              </v-btn>
              <v-btn
                style="height: 32px !important"
                class="custom-bold-button"
                depressed
                :disabled="vStateLoading"
                v-on:click="$emit('close', true)"
              >
                Close
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Dialog>
</template>
<script>
import { mapGetters } from "vuex";
import Dialog from "@/view/pages/partials/Dialog.vue";
import { GET_ENQUIRY_LINE_ITEM, SET_LOADING } from "@/core/services/store/visit.module";
import { ErrorEventBus } from "@/core/lib/message.lib";

export default {
  name: "line-item-dialog-v2",
  props: {
    productType: {
      type: String,
      default: null,
    },
    productDialog: {
      type: Boolean,
      default: false,
    },
    moduleType: {
      type: Number,
      default: 0,
    },
    unitList: {
      type: Array,
      default: () => [],
    },
    isType: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
    hideUnitAndCost: {
      type: Boolean,
      default: false,
    },
    emitFilters: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: null,
      category: "all",
      alphabet: "all",
      filter_categoty: null,
      useCustomItems: false,
      customLineItems: [],
      isMobile: false,
    };
  },
  components: {
    Dialog,
  },
  methods: {
    getStyle(productType) {
      if (this.moduleType != 8) {
        return productType == "goods" || productType == "parts"
          ? "width: 35%"
          : " width: 47%";
      }

      return "width: 82%";
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    checkAvailableQuantity(row) {
      if (row.product_type == "goods" || row.product_type == "parts") {
        if (Number(row.quantity) > Number(row.initial_stock)) {
          ErrorEventBus.$emit(
            "update:error",
            "Quantity exceeds available quantity"
          );
          return (row.quantity = row.initial_stock);
        }
      }
    },
    getDisabled(row) {
      if (
        this.moduleType &&
        this.moduleType == 7 &&
        row?.preventive_id > 0 &&
        row?.item_count > 0
      ) {
        return true;
      }
      return false;
    },
    initializeCustomItems() {
      if (this.items && this.items.length > 0) {
        this.customLineItems = this.items.map((item) => ({
          ...item,
          status: false,
          product: item.product || item.name || item.title || "",
          barcode: item.barcode || item.preventive_barcode || "",
          has_property: true,
        }));
        this.useCustomItems = true;
        console.log("Initialized custom items:", this.customLineItems);
      }
    },
    find_items() {
      let productType = this.productType;
      if (productType == "product") {
        productType = "goods";
      }
      this.$store.dispatch(SET_LOADING, true);
      this.$store
        .dispatch(GET_ENQUIRY_LINE_ITEM, {
          type: productType,
          search: this.search,
          category: this.category,
          alphabet: this.alphabet,
          customer: productType != "tools" ? this.vCustomerId : 0,
          start_date: this.prventiveRecurringSchedule?.start_date || null,
          end_date: this.prventiveRecurringSchedule?.dbEndDate || null,
        })
        .then((output) => {
          console.log({ output });
          this.emitFilterChange();
        })
        .catch((error) => {
          console.log({ error });
          this.emitFilterChange();
        })
        .finally(() => {
          this.$store.dispatch(SET_LOADING, false);
        });
    },
    save_line_item() {
      let selected_line_items = [];

      let status = false;
      for (let item of this.lineItemList) {
        if (item.status) {
          status = true;
          selected_line_items.push(item);
        }
      }
      let error = true;

      if (selected_line_items?.length > 0 && this.isType == 7) {
        for (let item of selected_line_items) {
          this.vSelectedLineItem.forEach((row) => {
            if (row.barcode == item.barcode) {
              ErrorEventBus.$emit(
                "update:error",
                `${item.barcode} already used `
              );
              error = false;
              return false;
            }
          });
        }
      }
      if (!error && this.isType == 7) {
        return false;
      }
      if (!status) {
        ErrorEventBus.$emit("update:error", `Please select Item.`);
        return false;
      }
      this.$emit("update-values", selected_line_items);
      this.$emit("close", true);
    },
    update_all_line_item(status) {
      if (this.moduleType == 7) {
        for (let i = 0; i < this.lineItemList.length; i++) {
          if (
            /* this.lineItemList[i].preventive_id == 0 &&  */ this.lineItemList[i]
              .item_count == 0
          ) {
            this.lineItemList[i].status = status;
          }
        }
      } else {
        for (let i = 0; i < this.lineItemList.length; i++) {
          this.lineItemList[i].status = status;
        }
      }
    },
    filter_cat(param) {
      this.category = param;
      console.log(this.category, this.category);
      // Only call find_items if NOT using custom items (useCustomItems = false)
      if (!this.useCustomItems) {
        this.find_items();
      }
      this.emitFilterChange();
    },
    filter_alpha(param) {
      this.alphabet = param;
      // Only call find_items if NOT using custom items (useCustomItems = false)
      if (!this.useCustomItems) {
        this.find_items();
      }
      this.emitFilterChange();
    },
    emitFilterChange() {
      if (this.emitFilters) {
        this.$emit('update-filters', {
          search: this.search,
          category: this.filter_categoty || this.category,
          alphabet: this.alphabet,
        });
      }
    },
    clearSearch() {
      this.search = null;
      this.handleSearch();
    },
    updateIsMobile() {
      this.isMobile = document.body.clientWidth <= 768;
    },
    handleSearch() {
      // Only call find_items if NOT using custom items
      if (!this.useCustomItems) {
        this.find_items();
      } else {
        this.emitFilterChange();
      }
    },
  },
  mounted() {
    this.updateIsMobile();
    window.addEventListener('resize', this.updateIsMobile);
    if (this.items && this.items.length > 0) {
      this.initializeCustomItems();
    } else if (this.productDialog) {
      this.find_items();
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  watch: {
    productDialog(newVal) {
      if (newVal && this.items && this.items.length > 0) {
        this.initializeCustomItems();
      } else if (newVal && !this.useCustomItems) {
        this.find_items();
      }
    },
    items: {
      handler(newVal) {
        if (newVal && newVal.length > 0 && this.productDialog) {
          this.initializeCustomItems();
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      "vCustomerId",
      "vLineItem",
      "vLineItemAlpha",
      "vStateLoading",
      "vLineItemCategory",
      "vLineItemUnit",
      "vSelectedLineItem",
      "prventiveRecurringSchedule",
    ]),
    dialog_width() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 80);
    },
    categoryStyle() {
      return this.isMobile ? {} : { maxWidth: '250px' };
    },
    lineItemList() {
      return this.useCustomItems ? this.customLineItems : this.vLineItem;
    },
    lineItemCategories() {
      return this.categories && this.categories.length > 0 ? this.categories : this.vLineItemCategory;
    },
    getSelectedItem() {
      return this.lineItemList.filter((item) => item.status).length;
    },
  },
};
</script>
<style scoped>
.custom_row {
  border-bottom: 1.5px solid #dbd7d7;
}
.custom_row:nth-child(even) {
  background: #fff4de;
}
.custom_row:hover {
  background: #fff4de;
}
.line-item-dialog .line-item-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.line-item-dialog .line-item-filters > * {
  flex: 1 1 0;
  min-width: 160px;
}
.line-item-dialog .line-item-filters .filter-control {
  width: 100%;
}
.line-item-dialog .line-item-filters .filter-button {
  min-width: 72px;
  max-width: 110px;
  padding-left: 8px;
  padding-right: 8px;
}
.line-item-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}
.line-item-title-text {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}
.line-item-title-label,
.line-item-title-count {
  white-space: nowrap;
}
.line-item-title-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.line-item-mobile-actions {
  display: none;
}
.line-item-title-actions .dialog-action-btn {
  min-width: 90px;
}
.line-item-dialog .line-item-product-label {
  min-height: 32px;
  display: flex;
  align-items: center;
  color: #24326d;
  font-size: 14px;
  line-height: 20px;
  flex: 1 1 auto;
  min-width: 0;
  margin-left: 8px;
}
.line-item-dialog .line-item-product-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}
.line-item-dialog .line-item-product-codes {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  flex: 0 0 auto;
  margin-left: -10px;
}
.line-item-dialog .line-item-description {
  margin: 4px 0 2px 8px;
  color: #5b6475;
  font-size: 12px;
  line-height: 16px;
  max-width: 100%;
}
.line-item-dialog .line-item-table-header {
  display: flex;
  flex-wrap: wrap;
}
.line-item-dialog .custom_row {
  display: flex;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .line-item-dialog .line-item-filters {
    flex-direction: column;
  }
  .line-item-dialog .line-item-filters .filter-item,
  .line-item-dialog .line-item-filters .v-btn,
  .line-item-dialog .line-item-filters .v-autocomplete {
    width: 100% !important;
    max-width: 100% !important;
  }
  .line-item-dialog .line-item-filters .filter-button {
    margin-left: 0 !important;
  }
  .line-item-dialog .line-item-filters .v-autocomplete {
    max-width: none !important;
  }
  .line-item-dialog .line-item-filters .filter-button,
  .line-item-dialog .line-item-filters .v-autocomplete {
    min-width: 72px;
    max-width: 110px;
    width: 100%;
  }
  .line-item-dialog .line-item-filters .filter-button {
    margin-top: 8px !important;
  }
  .line-item-dialog .line-item-filters .ml-2 {
    margin-left: 0 !important;
  }
  .line-item-dialog .line-item-product-label {
    margin-left: 4px;
  }
  .line-item-title {
    justify-content: space-between;
    flex-wrap: nowrap;
  }
  .line-item-title-text {
    flex: 1 1 auto;
    overflow: hidden;
    font-size: clamp(13px, 3.6vw, 15px);
    line-height: 1.2;
  }
  .line-item-title-label,
  .line-item-title-count {
    font-size: clamp(13px, 3.6vw, 15px);
  }
  .line-item-title-actions {
    width: 100%;
    justify-content: flex-end;
  }
  .line-item-dialog .desktop-line-item-actions {
    display: none !important;
  }
  .line-item-dialog .line-item-mobile-actions {
    display: flex;
    gap: 8px;
  }
  .line-item-dialog .line-item-mobile-actions .v-btn {
    flex: 1 1 0;
  }
  .line-item-dialog .line-item-table-header {
    flex-wrap: nowrap;
    align-items: center;
  }
  .line-item-dialog .line-item-table-header > div:first-child {
    width: auto !important;
    flex: 0 0 auto;
    display: flex !important;
    justify-content: flex-start !important;
    padding-bottom: 0;
  }
  .line-item-dialog .line-item-table-header > div:nth-child(2) {
    width: auto !important;
    flex: 1 1 auto;
    min-width: 0 !important;
    padding-left: 16px;
  }
  .line-item-dialog .line-item-table-header,
  .line-item-dialog .custom_row {
    flex-wrap: wrap;
  }
  .line-item-dialog .custom_row {
    align-items: flex-start;
  }
  .line-item-dialog .line-item-table-header > div,
  .line-item-dialog .custom_row > div {
    width: 100% !important;
    min-width: 0 !important;
  }
  .line-item-dialog .line-item-table-header .font-weight-600,
  .line-item-dialog .line-item-table-header .color-custom-blue,
  .line-item-dialog .custom_row .text-center,
  .line-item-dialog .custom_row .text-left {
    text-align: left !important;
  }
  .line-item-dialog .line-item-header-text {
    width: 100% !important;
  }
  .line-item-dialog .line-item-table-header .d-flex,
  .line-item-dialog .custom_row .d-flex {
    width: 100% !important;
  }
  .line-item-dialog .line-item-table-header > div:first-child,
  .line-item-dialog .custom_row > div:first-child {
    width: auto !important;
    display: flex !important;
    justify-content: flex-start !important;
    padding-bottom: 4px;
  }
  .line-item-dialog .line-item-table-header .text-center,
  .line-item-dialog .custom_row .text-center {
    justify-content: flex-start !important;
  }
  .line-item-dialog .custom_row > div:first-child {
    width: auto !important;
    flex: 0 0 auto;
    display: flex !important;
    justify-content: flex-start !important;
    padding-bottom: 0;
  }

  /* Mobile: vertically center the checkbox inside its cell */
  .line-item-dialog .custom_row > div:first-child {
    display: flex !important;
    align-items: center !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .line-item-dialog .custom_row > div:first-child .v-input--selection-controls,
  .line-item-dialog .custom_row > div:first-child .v-checkbox {
    margin-top: 0 !important;
    transform: none !important;
  }
  .line-item-dialog .custom_row > div:nth-child(2) {
    width: auto !important;
    flex: 1 1 auto;
    min-width: 0 !important;
    padding-left: 8px;
  }
  .line-item-dialog .custom_row > div:nth-child(2) > .d-flex {
    width: 100% !important;
    align-items: flex-start;
  }
  .line-item-dialog .custom_row > div:nth-child(2) > .d-flex > div:first-child {
    flex: 0 0 auto;
  }
  .line-item-dialog .custom_row > div:nth-child(2) > .d-flex > div:nth-child(2) {
    flex: 1 1 auto;
    min-width: 0;
  }
  .line-item-dialog .line-item-qty-cell {
    width: calc(100% - 40px) !important;
    margin-left: 40px;
    margin-top: 4px !important;
  }

  /* Ensure checkbox vertically centers in mobile rows */
  .line-item-dialog .custom_row {
    align-items: center !important;
  }
  .line-item-dialog .custom_row > div:first-child {
    align-self: stretch !important;
    height: 100% !important;
    min-height: 100% !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .line-item-dialog .custom_row > div:first-child .v-input--selection-controls,
  .line-item-dialog .custom_row > div:first-child .v-input--selection-controls__input,
  .line-item-dialog .custom_row > div:first-child .v-checkbox {
    margin-top: 0 !important;
    transform: none !important;
    top: 0 !important;
  }
  .line-item-dialog .product-header {
    text-align: left !important;
    padding-left: 8px;
  }
  .line-item-dialog .quantity-header {
    display: none !important;
  }
}
</style>
